import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { AlertCircle, X, ArrowRight } from "lucide-react";

const DISMISS_KEY = "bizma:profile-completion:dismissed";

export default function ProfileCompletionBanner() {
  const { user } = useAuth();
  const [missing, setMissing] = useState([]);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === "1");
    (async () => {
      if (!user) return;
      const issues = [];
      if (!user.birthdate) issues.push({ text: "tanggal lahir", to: "/app/me" });
      if (!user.socials || !Object.values(user.socials).some(v => v)) issues.push({ text: "sosial media", to: "/app/me" });
      try {
        const { data } = await api.get("/businesses/mine/list");
        const noLocation = (data || []).find(b => !b.lat || !b.lng);
        if (noLocation) issues.push({ text: "titik peta bisnis", to: `/app/businesses/${noLocation.business_id}/edit` });
        if (!(data || []).length) issues.push({ text: "data bisnis", to: "/app/businesses/new" });
      } catch (e) { /* silent */ }
      setMissing(issues);
    })();
  }, [user]);

  if (!user || dismissed || missing.length === 0) return null;
  const primary = missing[0];
  const others = missing.slice(1).map(m => m.text).join(", ");
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); };

  return (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 p-4 rounded-2xl bg-bizma-terracotta/10 border border-bizma-terracotta/30" data-testid="profile-completion-banner">
      <AlertCircle size={20} className="text-bizma-terracotta shrink-0"/>
      <div className="flex-1 text-sm">
        <span className="font-medium text-bizma-ink">Lengkapi profilmu — </span>
        <span className="text-bizma-subtext">
          {missing.length === 1
            ? `masih ada ${primary.text} yang belum diisi.`
            : `masih ada ${primary.text}${others ? `, dan ${others}` : ""} yang belum diisi.`}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Link to={primary.to} className="btn-primary text-sm py-2 px-4" data-testid="profile-complete-cta">Lengkapi <ArrowRight size={14}/></Link>
        <button onClick={dismiss} className="text-bizma-subtext hover:text-bizma-ink p-2 transition-colors" aria-label="Tutup" data-testid="profile-banner-dismiss"><X size={16}/></button>
      </div>
    </div>
  );
}
